export default "__VITE_ASSET__CG69kXCC__"